import React from "react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import {useGetHelpTextForGroupName} from "utils/utility";
import {ChevronDownIcon} from "@heroicons/react/24/outline";
import {GroupNameItem} from "utils/upsellsUtils";

const BookingUpsellGroupName = (props: {groupNameItem: GroupNameItem; isOpen: boolean; setIsOpen: (isOpen: boolean) => void}) => {
    const {t} = useTranslation();
    const {getGroupName} = useGetHelpTextForGroupName();
    return (
        <div className={"BookingUpsellGroupName flex flex-col items-center justify-center w-full relative"}>
            <div
                className={
                    "grid grid-cols-[48px,1fr,40px] sm:grid-cols-[64px,240px,1fr,40px] justify-start gap-4 sm:gap-6 items-center w-full bg-white rounded-lg py-6 pl-4 pr-4 border-b border-gray-300"
                }
            >
                <div className={"col-start-1 size-12 sm:size-16 rounded-lg shrink-0"}>
                    <img src={props.groupNameItem.items[0].image as string} className={"rounded-lg w-full h-full object-cover"} alt={"Image placeholder"} />
                </div>
                <span className={"text-base sm:text-xl font-bold shrink-0 basis-[200px]"}>{props.groupNameItem.groupName}</span>

                <div
                    className={
                        "row-start-2 sm:row-start-1 sm:col-start-3 col-start-1 col-end-4 sm:col-end-4 flex items-center justify-start gap-4 sm:gap-5 w-full relative"
                    }
                >
                    {getGroupName(props.groupNameItem.groupName).map((name, i) => (
                        <div key={i} className={"font-medium text-xxs sm:text-sm px-3 py-1.5 bg-gray-100 rounded-md"}>
                            {name}
                        </div>
                    ))}
                </div>

                <button
                    className={clsx(
                        "BookingUpsellGroupNameButtonOpen col-start-3 sm:col-start-4 sm:col-end-5 sm:row-start-1 flex flex-col items-center justify-center font-medium text-black gap-y-6"
                    )}
                    type={"button"}
                    onClick={() => props.setIsOpen(!props.isOpen)}
                >
                    <span
                        className={clsx(
                            "rounded-lg border-arbo-orange border-2 flex justify-center items-center hover:bg-opacity-90 duration-500 transition-all",
                            "size-8 md:size-10",
                            props.isOpen ? "bg-white" : "bg-arbo-orange"
                        )}
                    >
                        <ChevronDownIcon className={clsx("w-6 h-6 md:w-9 md:h-9", props.isOpen ? "rotate-180" : "")} />
                    </span>
                </button>
            </div>
        </div>
    );
};

export default BookingUpsellGroupName;
